export default {
    name: 'DatesOperation',

    props: {
        operation: {
            type: Object,
            required: true
        }
    }
};
